import {
  AddTarget,
  addTarget,
  addGroup,
  AddGroupData,
  batchGroupCopy,
  BatchGroupCopyData,
  deleteEmail,
  DeleteEmailData,
  deleteGroup,
  DeleteGroupData,
  editGroup,
  EditGroupData,
  GetTargetList,
  getTargetList,
  getGroupList,
  GetGroupData,
  saveEmail,
  SaveEmailData,
  UpAuto,
  upAuto,
  Loadscv,
  loadscv,
  getTagList,
  PutName,
  putName,
  putAppend,
  PutAppend,
  putTag,
  postName,
  PostName,
  getTask,
  GetTask,
  deleteTag,
  DeleteTag,
  PutContactsTag,
  putContactsTag,
  getTotal,
  getChart,
  getGroupListOrderAware,
  getTaskChart,
  getDomain,
  getCount,
  GetCount,
  GetGroupList,
  getTrend,
} from '@/api/target'
import { Message } from '@/components/message'
import { Dispaths } from '@/types'
import { useDebounce, useRequest } from 'ahooks'
import { message } from 'antd'
import { Key, useEffect } from 'react'
import { Group } from '.'

interface UseGetGroupProps {
  groupParams: GetGroupData
  setSelectGroup: Dispaths<Group | undefined>
  getTaskList: (GetTask) => void
  selectGroup: Group | undefined
  createFlag: React.MutableRefObject<string>
}

//  获取组
export const useGetGroup = (props: UseGetGroupProps) => {
  // eslint-disable-next-line @typescript-eslint/no-shadow
  const { groupParams, setSelectGroup, selectGroup, createFlag, getTaskList } = props
  const debouncedGroupParams = useDebounce(groupParams, { wait: 500 })
  const { data, run } = useRequest(() => getGroupList(groupParams), {
    refreshDeps: [debouncedGroupParams],
    onError(err: any) {
      Message.error(err?.msg || '分组信息加载失败')
    },
    onSuccess(res: any) {
      let group = null
      if (createFlag.current) {
        group = res?.data?.items?.[res?.data?.items.length - 1]
      } else {
        group = res?.data?.items?.[0]
      }
      if (group) {
        if (createFlag.current) {
          const createGroup = res.data.items.find(item => item.name === createFlag.current)
          if (createGroup) {
            setSelectGroup(createGroup)
            return
          }
          createFlag.current = null
        }
        if (selectGroup && res.data.items.some(item => item.id === selectGroup.id)) {
          return
        }
        setSelectGroup(group)
        if (group.id !== '') getTaskList({ group_id: group.id })
      } else {
        setSelectGroup(undefined)
      }
    },
  })
  return [data?.data, run] as const
}
//  获取所有组
export const useGetGroupAll = () => {
  const { data, runAsync: run } = useRequest((datas: GetGroupData) => getGroupList(datas), {
    onError(err: any) {
      Message.error(err?.msg || '分组信息加载失败')
    },
  })
  return [data?.data?.items || [], run] as const
}
// 获取所有部门
export const useGetGroupList = () => {
  const { runAsync: run, data } = useRequest((datas: GetGroupList) => getGroupList(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '部门信息加载失败')
    },
  })
  return [run, data?.data] as const
}
// 删除组
export const useDeleteGroup = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteGroupData) => deleteGroup(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '分组删除失败')
    },
  })
  return [run, loading] as const
}

// 添加组
export const useAddGroup = () => {
  const { runAsync: run } = useRequest((data: AddGroupData) => addGroup(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '添加失败')
    },
  })

  return [run] as const
}

// 编辑组
export const useEditGroup = () => {
  const { runAsync: run } = useRequest((data: EditGroupData) => editGroup(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '编辑失败')
    },
  })
  return [run] as const
}

// 添加邮箱
export const useAddTarget = () => {
  const { runAsync: run, loading } = useRequest((data: AddTarget) => addTarget(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '邮件添加失败')
    },
  })
  return [run, loading] as const
}

// 获取邮件列表
interface UseGetEmailListProps {
  // getEmailListParams: Omit<GetEmailListData, 'group_id'>
  selectGroup: Group | undefined
  setGetEmailListParams: Dispaths<Omit<GetTargetList, 'group_id'>>
  setlistSelectKey: Dispaths<Key[]>
}
export const useGetEmailList = (props: UseGetEmailListProps) => {
  const { selectGroup, setGetEmailListParams, setlistSelectKey } = props
  const { data, run, loading, mutate } = useRequest(
    (getEmailListParams: Omit<GetTargetList, 'group_id'>) =>
      getTargetList({
        ...getEmailListParams,
        group_id: selectGroup?.id,
        email_keyword: getEmailListParams?.name_keyword,
      }),
    {
      loadingDelay: 1000,
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '邮件列表加载失败')
      },
    },
  )
  useEffect(() => {
    setGetEmailListParams({
      limit: 10,
      page: 1,
      tag_ids: [],
    })
    setlistSelectKey([])
  }, [selectGroup?.id])
  return [data?.data, run, loading, mutate] as const
}

// 删除邮件
export const useDeleteEmail = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteEmailData) => deleteEmail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除失败')
    },
  })

  return [run, loading] as const
}

// 编辑邮件
export const useSaveEmail = () => {
  const { runAsync: run, loading } = useRequest((data: SaveEmailData) => saveEmail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '编辑失败')
    },
  })

  return [run, loading] as const
}

// 批量转移
export const useBatchGroupCopy = () => {
  const { runAsync: run, loading } = useRequest(
    (data: BatchGroupCopyData) => batchGroupCopy(data),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '批量转移失败')
      },
    },
  )

  return [run, loading] as const
}
// 批量导入
export const useLoadscv = () => {
  const { runAsync: run, loading } = useRequest((data: Loadscv) => loadscv(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '批量导入失败')
    },
  })

  return [run, loading] as const
}
// 更新邮件账号
export const useUpAuto = () => {
  const { runAsync: run, loading } = useRequest((data: UpAuto) => upAuto(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '更新邮件账号失败')
    },
  })

  return [run, loading] as const
}
// 查询标签
export const useGetTagList = () => {
  const { runAsync: run, data } = useRequest(() => getTagList(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '查询标签失败')
    },
  })
  return [run, data?.data?.items] as const
}
// 修改名称
export const usePutName = () => {
  const { runAsync: run } = useRequest((data: PutName) => putName(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '修改名称失败')
    },
  })
  return [run] as const
}
// 批量追加邮箱tag
export const usePutAppend = () => {
  const { runAsync: run } = useRequest((data: PutAppend) => putAppend(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '批量追加邮箱失败')
    },
  })
  return [run] as const
}
// 批量覆盖邮箱tag
export const usePutTag = () => {
  const { runAsync: run } = useRequest((data: PutAppend) => putTag(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '批量覆盖邮箱失败')
    },
  })
  return [run] as const
}
// 批量新增标签
export const usePostName = () => {
  const { runAsync: run } = useRequest((data: PostName) => postName(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '批量新增标签失败')
    },
  })
  return [run] as const
}
// 删除标签
export const useDeltetName = () => {
  const { runAsync: run, loading } = useRequest((data: DeleteTag) => deleteTag(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除标签失败')
    },
  })
  return [run, loading] as const
}
// 修改标签
export const usePutContactsTag = () => {
  const { runAsync: run, loading } = useRequest((data: PutContactsTag) => putContactsTag(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '修改标签失败')
    },
  })
  return [run, loading] as const
}
// 获取最近任务列表
export const useGetTask = () => {
  const { runAsync: run, data } = useRequest((datas: GetTask) => getTask(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取最近任务列表失败')
    },
  })
  return [run, data?.data] as const
}
// 获取公司评分图表信息
export const useGetChart = () => {
  const { runAsync: run, data } = useRequest(() => getChart(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取公司评分图表信息失败')
    },
  })
  return [run, data?.data] as const
}
// 获取有任务的部门列表
export const useGetGroupListOrderAware = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getGroupListOrderAware(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取有任务的部门列表失败')
    },
  })
  return [run, loading, data?.data?.items] as const
}
// 获取部门最近十次任务趋势图
export const UseGetTaskChart = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest((datas: GetTask) => getTaskChart(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取部门最近十次任务趋势图失败')
    },
  })
  return [run, loading, data?.data || []] as const
}
// 获取可添加邮箱域名
export const useGetDomain = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest(() => getDomain(), {
    // manual: true,
    // loadingDelay: 10,
    onError(err: any) {
      Message.error(err?.msg || '获取可添加邮箱域名失败')
    },
  })
  return [run, data?.data?.items || [], loading] as const
}
// 获取评估目标数量
export const useGetTotal = () => {
  const { runAsync: run, data } = useRequest(() => getTotal(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取评估目标数量失败')
    },
  })
  return [run, data?.data || {}] as const
}
// 根据邮箱获取任务统计数量
export const useGetCount = () => {
  const { runAsync: run, data } = useRequest((datas: GetCount) => getCount(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '根据邮箱获取任务统计数量失败')
    },
  })
  return [run, data?.data || {}] as const
}
// 根据邮箱获取任务统计趋势
export const useGetTrend = () => {
  const { runAsync: run, data } = useRequest((datas: GetCount) => getTrend(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '根据邮箱获取任务统计趋势失败')
    },
  })
  return [run, data?.data || {}] as const
}
